import {
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  type ApplicationConfig,
} from "@angular/core";
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from "@angular/common/http";
import { provideRouter } from "@angular/router";
import {
  MSAL_INSTANCE,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalService,
  MsalGuard,
  MsalBroadcastService,
  MsalInterceptor,
} from "@azure/msal-angular";
import { provideDavacoFeedback } from "@davacolp/ui";

import { routes } from "./app.routes";
import { environment } from "../environments/environment";
import {
  MSALInstanceFactory,
  MSALGuardConfigFactory,
  MSALInterceptorConfigFactory,
} from "./core/auth/msal.config";
import { initializeMsal } from "./core/auth/msal-initializer";
import { CamelCaseInterceptor } from "./core/interceptors/camelcase.interceptor";
import { AuthTokenInterceptor } from "./core/interceptors/auth-token.interceptor";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    // MSAL Configuration
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
    },
    // MSAL Services
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    // Await MSAL initialize() + handleRedirectPromise() before the router's
    // initial navigation, so guards, interceptors and AuthService never touch
    // an uninitialized PublicClientApplication.
    provideAppInitializer(initializeMsal),
    // Report a Bug or Feature: dv-feedback posts to the feedback-service and
    // files the issue in this repository. Root-level, not on the route:
    // DvFeedbackService is providedIn root and cannot see route providers.
    // The AuthTokenInterceptor already attaches the AAD token to this base URL.
    provideDavacoFeedback({
      apiBaseUrl: environment.feedbackApiBase,
      githubOrg: "DavacoLP",
      githubRepo: "ctv2026",
    }),
    // CamelCase interceptor — converts all API response keys to camelCase
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CamelCaseInterceptor,
      multi: true,
    },
    // Auth token interceptor — appends Bearer token to all app API calls
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthTokenInterceptor,
      multi: true,
    },
    // HTTP Interceptor for adding tokens to requests (Microsoft Graph)
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
  ],
};
